export const TIPO_USUARIO_VARIANTS = [
  { id: 2, desc: "administrador" },
  { id: 5, desc: "app ruta" },
  { id: 6, desc: "app supervisor" },
];

export const STATUS_VARIANTS = [
  { id: 0, desc: "inactivo" },
  { id: 1, desc: "activo" },
];
